import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ClinicalTeamPage.scss'
import '../../../../../pages/styles.scss'
import tagSvg from '../../../../../../assets/images/WhoWeHelp/tag.svg'
import FooterSection from '../../../../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import { teamMembers } from '../../../../../../components/reusable/Common/Constant.js';
import clinicalMainImage from '../../../../../../assets/images/Community/Clinical.png'

const ClinicalTeamPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);
    return (
        <div className='clinical-team-page-container container'>
            <div className='clinical-team-page-section section-1'>
                <div className='clinical-team-page-section-content text'>
                    <h1>Meet the Team: <span className="highlight">Clinical</span></h1>
                    <p>The clinical team is a multidisciplinary group of physicians, advanced practice providers, nurses, and medical assistants, united by a commitment to delivering exceptional, accessible, and convenient specialty care to underserved populations.</p>
                    <div className='button-section'>
                        <Link className='btn' to="/careers-and-culture">
                            <i className='bx bx-plus'></i>
                            Explore Career Opportunities
                        </Link>
                    </div>
                </div>
                <div className='clinical-team-page-section-content image'>
                    <div className='image-container'>
                        <img src={clinicalMainImage} alt="" />
                    </div>
                </div>
            </div>
            <div className='clinical-team-page-section section-2'>
                <div className='clinical-team-page-section-content text'>
                    <div className='company-vision-title'>
                        <div className='tag' style={{
                            backgroundImage: `url(${tagSvg})`,
                        }}>
                            <span>Our Team</span>
                        </div>
                        <br />
                        <h1>Clinical</h1>
                    </div>
                    <div className='company-vision-para'>
                        <p>
                            Our clinicians are committed to providing personalized care while addressing systemic challenges such as fragmentation and limited access, which disproportionately affect individuals in congregate care settings.
                        </p>
                        <br />
                        <p>
                            <b>Clinical Team Roles: </b>Nurse Practitioners (NP), Physician Assistants, Advanced Practice Providers (APP),  and Physiatrists.
                        </p>
                    </div>
                </div>
                <hr className="section-divider" />
                <div className='clinical-team-page-section-content text'>
                    <div className='company-vision-point bubble-point'>
                        <h2>Collaborative</h2>
                    </div>
                    <div className='company-vision-point bubble-point'>
                        <h2>Creative</h2>
                    </div>
                    <div className='company-vision-point bubble-point'>
                        <h2>Compassionate</h2>
                    </div>
                </div>
            </div>
            <div className='clinical-team-page-section section-3'>
                <div className='wrapper'>
                    <div className='clinical-team-page-section-content image'>
                        <div className='image-container image-1'>
                            <img src={teamMembers.randyDr.image} alt="" />
                            <h1>{teamMembers.randyDr.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.randyDr.image,
                                        pageType: teamMembers.randyDr.pageType,
                                        name: teamMembers.randyDr.name,
                                        designation: teamMembers.randyDr.designation,
                                        message: teamMembers.randyDr.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-container image-2'>
                            <img src={teamMembers.aaron.image} alt="" />
                            <h1>{teamMembers.aaron.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.aaron.image,
                                        pageType: teamMembers.aaron.pageType,
                                        name: teamMembers.aaron.name,
                                        designation: teamMembers.aaron.designation,
                                        message: teamMembers.aaron.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-container image-3'>
                            <img src={teamMembers.timothy.image} alt="" />
                            <h1>{teamMembers.timothy.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.timothy.image,
                                        pageType: teamMembers.timothy.pageType,
                                        name: teamMembers.timothy.name,
                                        designation: teamMembers.timothy.designation,
                                        message: teamMembers.timothy.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-container image-4'>
                            <img src={teamMembers.carmen.image} alt="" />
                            <h1>{teamMembers.carmen.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.carmen.image,
                                        pageType: teamMembers.carmen.pageType,
                                        name: teamMembers.carmen.name,
                                        designation: teamMembers.carmen.designation,
                                        message: teamMembers.carmen.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='wrapper-2'>
                    <div className='clinical-team-page-section-content image'>
                        <div className='image-1'>
                            <div className='image-container'>
                                <img src={teamMembers.nurse1.image} alt="" />
                            </div>
                            <h1>{teamMembers.nurse1.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.nurse1.image,
                                        pageType: teamMembers.nurse1.pageType,
                                        name: teamMembers.nurse1.name,
                                        designation: teamMembers.nurse1.designation,
                                        message: teamMembers.nurse1.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-2'>
                            <div className='image-container'>
                                <img src={teamMembers.nurse2.image} alt="" />
                            </div>
                            <h1>{teamMembers.nurse2.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.nurse2.image,
                                        pageType: teamMembers.nurse2.pageType,
                                        name: teamMembers.nurse2.name,
                                        designation: teamMembers.nurse2.designation,
                                        message: teamMembers.nurse2.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-3'>
                            <div className='image-container'>
                                <img src={teamMembers.nurse3.image} alt="" />
                            </div>
                            <h1>{teamMembers.nurse3.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.nurse3.image,
                                        pageType: teamMembers.nurse3.pageType,
                                        name: teamMembers.nurse3.name,
                                        designation: teamMembers.nurse3.designation,
                                        message: teamMembers.nurse3.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-4'>
                            <div className='image-container'>
                                <img src={teamMembers.nurse4.image} alt="" />
                            </div>
                            <h1>{teamMembers.nurse4.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.nurse4.image,
                                        pageType: teamMembers.nurse4.pageType,
                                        name: teamMembers.nurse4.name,
                                        designation: teamMembers.nurse4.designation,
                                        message: teamMembers.nurse4.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-5'>
                            <div className='image-container'>
                                <img src={teamMembers.nurse5.image} alt="" />
                            </div>
                            <h1>{teamMembers.nurse5.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.nurse5.image,
                                        pageType: teamMembers.nurse5.pageType,
                                        name: teamMembers.nurse5.name,
                                        designation: teamMembers.nurse5.designation,
                                        message: teamMembers.nurse5.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-6'>
                            <div className='image-container'>
                                <img src={teamMembers.nurse6.image} alt="" />
                            </div>
                            <h1>{teamMembers.nurse6.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.nurse6.image,
                                        pageType: teamMembers.nurse6.pageType,
                                        name: teamMembers.nurse6.name,
                                        designation: teamMembers.nurse6.designation,
                                        message: teamMembers.nurse6.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-7'>
                            <div className='image-container'>
                                <img src={teamMembers.nurse7.image} alt="" />
                            </div>
                            <h1>{teamMembers.nurse7.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.nurse7.image,
                                        pageType: teamMembers.nurse7.pageType,
                                        name: teamMembers.nurse7.name,
                                        designation: teamMembers.nurse7.designation,
                                        message: teamMembers.nurse7.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-1'>
                            <div className='image-container'>
                                <img src={teamMembers.physician1.image} alt="" />
                            </div>
                            <h1>{teamMembers.physician1.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.physician1.image,
                                        pageType: teamMembers.physician1.pageType,
                                        name: teamMembers.physician1.name,
                                        designation: teamMembers.physician1.designation,
                                        message: teamMembers.physician1.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-2'>
                            <div className='image-container'>
                                <img src={teamMembers.physician2.image} alt="" />
                            </div>
                            <h1>{teamMembers.physician2.name}</h1>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.physician2.image,
                                        pageType: teamMembers.physician2.pageType,
                                        name: teamMembers.physician2.name,
                                        designation: teamMembers.physician2.designation,
                                        message: teamMembers.physician2.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className='wrapper-2'>
                    <div className='clinical-team-page-section-content image'>
                        
                    </div>
                </div> */}
            </div>
            <FooterSection />
        </div>
    )
}

export default ClinicalTeamPage
